module.exports = __webpack_public_path__ + "static/img/icon_self_identification.ad2920f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_self_identification.svg
// module id = tG+b
// module chunks = 10